import React, { useEffect } from 'react';
import { StopCircle, User, Calendar } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { selectStatuses } from '../../core/redux/status/selectors';

import { actions as inventoryActions, fetchInventoriesWithFilters } from './store/slice';
import { Link } from 'react-router-dom';
import { useTransformOptions } from 'Core/hooks';
import { fetchStatuses } from '../../core/redux/status/slice';
import InventorySearch from './inventory-search';
import InventoryDetailSearch from './inventory-detail-search';

const { setInventoryStatus, setInventoryStartDate, setInventoryEndDate } = inventoryActions;

const InventorySerialFilter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStatuses());
  }, [dispatch]);

  const statuses = useSelector(selectStatuses);
  const {
    status: selectedStatus = '',
    startDate = '',
    endDate = '',
  } = {};

  const statusOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const handleStatusChange = selected => {
    dispatch(setInventoryStatus(selected));
  };

  const onInventorySearch = () => {
    dispatch(fetchInventoriesWithFilters());
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
          <div className="col-lg-4 col-sm-6 col-12">
            <InventoryDetailSearch />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventorySerialFilter;
